export default "__VITE_ASSET__CjA2zal6__"